package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
data class GameState(
    val gameId: String,
    val board: Board,
    val players: List<Player>,
    val currentPlayerIndex: Int,
    val gamePhase: GamePhase,
    val currentHand: List<Pin>,
    val playerHands: Map<String, List<Pin>> = emptyMap(),
    val handCount: Int,
    val started: Boolean,
    val moves: List<Move> = emptyList(),
    val currentPlayerId: String? = null
) {
    // Helper to get current player
    val currentPlayer: Player
        get() = if (players.isNotEmpty() && currentPlayerIndex in players.indices) {
            players[currentPlayerIndex]
        } else players[0]

    fun getAvailablePins(): List<Pin> {
        return currentHand
    }
}
